import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {yupResolver} from '@hookform/resolvers/yup'
import {FormProvider, useForm} from 'react-hook-form'
import {InputDateWrapper} from '../../../../../../components/UI/Form/Input'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM, SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {endProcessWashBatchSchema} from '../../../../schema/laundryBatch'
import {endProcessWashBatch} from '../../../../services'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import moment from 'moment'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

const ModalFinishWash: FC<Props> = ({show, setShow}) => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {setUpdateTable, clearSelected} = useKTable()
  const [loading, setLoading] = useState<boolean>(false)
  const methods = useForm({
    resolver: yupResolver(endProcessWashBatchSchema),
  })
  const {
    handleSubmit,
    setValue,
    watch,
    formState: {errors},
  } = methods
  const handleClose = () => {
    setShow(false)
  }

  useEffect(() => {
    setValue('tipeAdmin', currentTabItem.typeAdmin)
    if (currentTabItem.typeAdmin === 'EXTERNO') {
      setValue('fechaDevolucionReal', moment().format('YYYY-MM-DD'))
    }
    if (currentTabItem.typeAdmin === 'COMPAÑIA' || currentTabItem.typeAdmin === 'COMPAÑÍA') {
      setValue('fechaRealSalida', moment().format('YYYY-MM-DD'))
    }
  }, [currentTabItem.detailRow])
  const onSubmit = async (data: any) => {
    const {
      id,
      lugarLavado,
      proveedorId,
      puntoId,
      fechaRealSalida,
      fechaRealInicio,
      fechaEntregaProveedor,
      fechaProgramadaProveedor,
      fechaDevolucionReal,
    } = currentTabItem.detailRow

    let obj = {
      id,
      lugarLavado,
    }
    setLoading(true)
    let isType =
      currentTabItem.typeAdmin === 'COMPAÑÍA'
        ? {
            ...obj,
            fechaRealSalida,
            fechaRealLavado: fechaRealInicio,
            puntoId,
            tipoLavado: currentTabItem.typeWash,
            ...data,
          }
        : {
            // EXTERNO
            ...obj,
            fechaEntregaProveedor,
            fechaProgramadaProveedor,
            fechaDevolucionReal,
            proveedorId,
            tipoLavado: currentTabItem.typeWash,
            ...data,
          }
    const {data: response} = await endProcessWashBatch(isType)
    if (!response.error) {
      ShowSnackBar(SUCCESS_MESSAGE_CREATE)
      setUpdateTable(true)
      changeCurrentTabItem({
        ...currentTabItem,
        typeAdmin: '',
        typeProcess: '',
        isStartLaundry: false,
        isFinishOut: false,
        isFinishLaundry: false,
        isCancel: false,
        detailRow: null,
      })
      clearSelected()
      setLoading(false)
      setShow(false)
    } else {
      ShowSnackBar(response.message, 'error')
      setLoading(false)
    }
    try {
    } catch (error) {
      setLoading(false)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Finalizar Lavado</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              {currentTabItem.typeAdmin === 'COMPAÑÍA' ? (
                <div className='row'>
                  <div className='col-lg-12'>
                    <InputDateWrapper labelText='Fecha fin real de lavado' name='fechaRealSalida' />
                  </div>
                </div>
              ) : (
                <div className='row'>
                  <div className='col-lg-12'>
                    <InputDateWrapper
                      labelText='Fecha de devolución real de lavado'
                      name='fechaDevolucionReal'
                    />
                  </div>
                </div>
              )}
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalFinishWash}
